/** Runs the thunk body only if window.GTM is available; otherwise warns and returns. */
const withGTM = (thunkBody) => (dispatch, getState) => {
  if (!window.GTM) {
    if (process.env.NODE_ENV === "development") {
      console.error(
        [
          "[registerGTMEvent] Google Tag Manager is not available.",
          "\n\nThis message is only shown in development; in production it will fail silently.",
        ].join(" "),
      );
    }
    return;
  }

  return thunkBody(dispatch, getState);
};

/** Wraps a function that returns a thunk so the thunk is run through withGTM. */
const wrapWithGTM = (fn) => {
  return (...args) => withGTM(fn(...args));
};

export default wrapWithGTM;
